import React, { useState, useEffect, useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import { auth } from '../firebase';
import { useOrganization } from '../context/OrganizationContext';
import { Contexto, useEstadoDeBandeja } from './estadoDeBandeja';
import { useDatosDeBandeja } from './datosDeBandeja';

/**
 * Ruta de LAYOUT · compone la memoria de sesión con la lista viva.
 *
 * Las dos piezas viven fuera por el mismo motivo, que es de PRUEBAS y no de estilo:
 *
 *   · `estadoDeBandeja.js`  filtros, búsqueda y ancla — puro, sin enrutador ni Firebase
 *   · `datosDeBandeja.js`   el oyente y la paginación
 *   · `fusionDeChats.js`    la fusión entre página viva y cola congelada — pura
 *
 * El jest de CRA **no resuelve `react-router-dom`** en este repositorio —es la causa de
 * que `App.test.js` sea la única suite roja, desde antes de esto— así que todo lo que
 * importe `<Outlet />` queda fuera del alcance de las pruebas. Aquí sólo queda eso.
 *
 * ⚠️ QUE EL OYENTE VIVA AQUÍ ES LO QUE DA EL AHORRO. Dentro de `Chats` se desengancharía
 * al abrir un chat y se reengancharía al volver: la página entera, otra vez. Aquí
 * sobrevive el viaje, y al volver la lista ya está fresca sin releer nada.
 */
export default function SesionDeBandeja() {
  const { context, loading: orgLoading } = useOrganization();
  const [user, setUser] = useState(null);

  // La sesión se suscribe AQUÍ y no en `Chats`: si se desmontara al abrir un chat, el
  // oyente de datos perdería su `user` y se reengancharía al volver.
  useEffect(() => auth.onAuthStateChanged(setUser), []);

  const sesion = useEstadoDeBandeja();
  // La cuenta elegida va a la CONSULTA (commit 10), no a un filtro en memoria.
  const accountId = sesion.filtros.cuenta && sesion.filtros.cuenta !== 'todas' ? sesion.filtros.cuenta : null;
  const datos = useDatosDeBandeja({ user, context, orgLoading, accountId });

  const valor = useMemo(() => ({ ...sesion, ...datos, user }), [sesion, datos, user]);

  return (
    <Contexto.Provider value={valor}>
      <Outlet />
    </Contexto.Provider>
  );
}
